import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container container--slim step-thx-page step--upload-result--succeeded" }
const _hoisted_2 = { class: "container__client-zone-header" }
const _hoisted_3 = { class: "image-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "container__subheader t-center t-bold" }

import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { SET_STEP } from '@/constants/mutation-types';
import store from '@/store';
import okIcon from '@/assets/ok2.svg';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TRANSLATION_KEY = 'steps.esgSubmit';

// i18n
const { t } = useI18n();

const handleRedirect = () => {
    store.state.navigationService.goToRoute('newLogin');
};

onMounted(() => {
    store.commit(SET_STEP, 'esgSubmit');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)(`${TRANSLATION_KEY}.header`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "w-80",
        src: _unref(okIcon),
        alt: "Success"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)(`${TRANSLATION_KEY}.subheader`)), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "button button--submit",
      onClick: handleRedirect
    }, _toDisplayString(_ctx.$t(`${TRANSLATION_KEY}.logInToYourAccount`)), 1)
  ]))
}
}

})